import PlainMarkdownText from '@basic/PlainMarkdownText';
import ChevronDownIcon from '@icons/ChevronDownIcon';
import ChevronUpIcon from '@icons/ChevronUpIcon';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { parseHighlightedText } from './highlighters';

interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
  accentColor: string;
}

export default function FAQItem({ question, answer, isOpen, onToggle, accentColor }: FAQItemProps) {
  return (
    <div
      onClick={onToggle}
      className={classNames(
        'rounded-lg border',
        'cursor-pointer',
        isOpen ? '' : 'border-primary',
        isOpen ? setupForDark('bg-page') : setupForDark('bg-landing-surface-card')
      )}
      style={isOpen ? { borderColor: accentColor } : undefined}
    >
      <div className='flex gap-xl items-start p-xl'>
        <div className='flex-1 flex flex-col gap-md'>
          <div className='flex flex-wrap gap-lg items-center w-full'>
            <div
              className={classNames(
                'flex-1 font-bold',
                'leading-[1.2]',
                setupForDark('text-white'),
                'text-[16px] @[640px]:text-[20px]'
              )}
            >
              {parseHighlightedText(question, 'text-white', undefined, accentColor)}
            </div>
            <div
              className={classNames(
                'flex items-center justify-center rounded-lg shrink-0 w-[40px] h-[40px]',
                isOpen ? '' : setupForDark('bg-white')
              )}
              style={isOpen ? { backgroundColor: accentColor } : undefined}
            >
              <div className={`transition-transform duration-200`}>
                {isOpen ? (
                  <ChevronUpIcon size={18} className={classNames(setupForDark('text-white'))} />
                ) : (
                  <ChevronDownIcon size={18} className={classNames(setupForDark('text-black'))} />
                )}
              </div>
            </div>
          </div>
          {isOpen && (
            <div
              className={classNames(
                'font-normal leading-[1.4] w-full',
                setupForDark('text-white'),
                'text-[16px] @[640px]:text-[20px]'
              )}
            >
              <PlainMarkdownText text={answer} accentColor={accentColor} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
